import 'extensions/ui-components/x-date-input';
import 'extensions/ui-components/x-quantity';
import {FormElementMixin} from 'extensions/ui-mixins/form-element/lib/form-element-mixin';
import {defineCustomElement} from 'extensions/ui-utils';
import {LitElement, html, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './x-mord-item.scss?as=stylesheet';

// eslint-disable-next-line new-cap
export class ModifyOrderItem extends FormElementMixin(LitElement) {
	static get styles () {
		return [stylesheet];
	}

	// eslint-disable-next-line max-lines-per-function
	static get properties () {
		return {
			code: {
				type: String
			},
			deliveryDate: {
				attribute: 'delivery-date',
				type: String
			},
			disableQuantity: {
				attribute: 'disable-quantity',
				type: Boolean
			},
			formattedDeliveryDate: {
				attribute: 'formatted-delivery-date',
				type: String
			},
			hideDeliveryDate: {
				attribute: 'hide-delivery-date',
				type: Boolean
			},
			id: {
				type: String
			},
			lineId: {
				attribute: 'line-id',
				type: Number
			},
			quantity: {
				type: Number
			},
			quantityError: {
				attribute: 'quantity-error',
				type: Boolean
			}
		};
	}

	// eslint-disable-next-line max-lines-per-function
	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.code = 'code';

		/**
		 * @type {string}
		 */
		this.deliveryDate = '';

		/**
		 * @type {boolean}
		 */
		this.disableQuantity = false;

		/**
		 * @type {string}
		 */
		this.formattedDeliveryDate = '';

		/**
		 * @type {boolean}
		 */
		this.hideDeliveryDate = false;

		/**
		 * @type {string}
		 */
		this.id = '';

		/**
		 * @type {number}
		 */
		this.lineId = 0;

		/**
		 * @type {number}
		 */
		this.quantity = 0;

		/**
		 * @type {boolean}
		 */
		this.quantityError = false;

		/**
		 * @type {object}
		 */
		this.formattedValues = {};
	}

	connectedCallback () {
		super.connectedCallback();

		this.updateValue();
	}

	// eslint-disable-next-line max-lines-per-function
	renderInnerForm () {
		const classes = {
			container: true,
			'quantity-error': this.quantityError
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="actions">
					${this.renderDeliveryDate()}
					<div class="quantity-form">
						${this.disableQuantity ? html`<span class="quantity quantity-display">${this.quantity}</span>` : html`<x-quantity class="quantity" name="Quantity" value="${this.quantity}" hide-buttons-mobile hide-buttons-tablet min="0" @change="${this.handleQuantityChange}"></x-quantity>`}
					</div>
				</div>
			</div>
		`;
	}

	renderDeliveryDate () {
		if (this.hideDeliveryDate && !this.deliveryDate) {
			return nothing;
		}

		return html`
			<div class="delivery-date-form">
				<x-date-input disable-weekends name="DatePicker" value="${this.dateTimeFormat}" @change="${this.handleDateChange}"></x-date-input>
			</div>
		`;
	}

	async handleDateChange (e) {
		const dateElement = e.target;
		let newDate = '';
		if (dateElement?.value !== '') {
			const date = new Date(dateElement?.value);
			newDate = date.toISOString().substring(0, 19);
		}

		if (this.deliveryDate === newDate) {
			return;
		}

		this.deliveryDate = newDate;

		await this.updateComplete;

		this.updateValue();
	}

	handleQuantityChange (e) {
		if (this.quantity !== e?.detail?.value) {
			this.quantity = e.detail.value;
		}

		this.updateValue();
	}

	updateValue () {
		this.formattedValues = {
			code: this.code,
			date: this.deliveryDate,
			id: this.id,
			lineId: this.lineId,
			quantity: this.quantity
		};
	}

	get dateTimeFormat () {
		if (!this.deliveryDate) {
			return '';
		}

		const d = new Date(this.deliveryDate);
		return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
	}
};

defineCustomElement('x-mord-item', ModifyOrderItem);
